import React from "react";
import { CaptureToolMenu } from "./Components/CaptureToolMenu";
import { CaptureController } from "../../Controller/3DController/Captuire/CaptureController";


export interface ICaptureToolToolProps {
  captureController:CaptureController
}

export interface Props {
  toolProps:ICaptureToolToolProps
}

export interface State {
}

export class CaptureTool extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render = () => {
    const { captureController } = this.props.toolProps;

    return(
      <CaptureToolMenu
        captureController={captureController}
      />
    )
  };
};// /class